export default __webpack_public_path__ + "static/media/cochin2.4a40383c.jpg";